import { BrComerceApiService } from "../services/BrComerceApiService";

const handleAddressChange = async (field, value, setAddress, setLoading) => {
    const api = new BrComerceApiService();

    setAddress((prevAddress) => {

        const newState = {
            ...prevAddress,
            [field]: value,
        };

        if (field === "zip") {
            const isValid = /^[0-9]{8}$/.test(value);
            newState.zipOK = isValid ? "ok" : "notOk";
            newState.zipError = isValid ? "" : "CEP inválido";
        }

        if (field === "street") {
            newState.streetOK = value.length > 2 ? "ok" : "notOk";
            newState.streetError = value.length > 2 ? "" : "Rua muito curta";
        }

        if (field === "neighborhood") {
            newState.neighborhoodOK = value.length > 2 ? "ok" : "notOk";
            newState.neighborhoodError = value.length > 2 ? "" : "Bairro muito curto";
        }

        if (field === "number") {
            if (value === "") {
                newState.numberOK = "";
                newState.numberError = "";
            } else {
                const isValid = /^\d{1,5}$/.test(value);;
                newState.numberOK = isValid ? "ok" : "notOk";
                newState.numberError = isValid ? "" : "Número inválido";
            }
        }

        if (field === "uf") {
            const validUFs = ["AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA", "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN", "RS", "RO", "RR", "SC", "SP", "SE", "TO"];
            const isValid = validUFs.includes(value.toUpperCase());
            newState.ufOK = isValid ? "ok" : "notOk";
            newState.ufError = isValid ? "" : "UF inválida";
        }

        return newState;
    });

    if (field === "zip" && /^[0-9]{8}$/.test(value)) {
        try {
            setLoading(true);
            let response = await api.makeHttpRequest({
                method: "POST",
                url: `/addressbook/getAddress`,
                data: {
                    zipCode: value
                }
            })

            setAddress((prevAddress) => ({
                ...prevAddress,
                zipOK: "ok",
                zipError: "",
                street: response.logradouro || "",
                streetOK: response.logradouro ? "ok" : "",
                streetError: response.logradouro ? "" : "Não encontrado",
                neighborhood: response.bairro || "",
                neighborhoodOK: response.bairro ? "ok" : "",
                neighborhoodError: response.bairro ? "" : "Não encontrado",
                uf: response.uf || "",
                ufOK: response.uf ? "ok" : "",
                ufError: response.uf ? "" : "Não encontrado",
                city: response.localidade || "",
                cityOK: response.localidade ? "ok" : "",
                cityError: response.localidade ? "" : "Não encontrado",
            }));

        } catch (error) {
            setAddress((prevAddress) => ({
                ...prevAddress,
                zipOK: "notOk",
                zipError: "CEP não encontrado",
                street: "",
                streetOK: "",
                streetError: "",
                neighborhood: "",
                neighborhoodOK: "",
                neighborhoodError: "",
                uf: "",
                ufOK: "",
                ufError: "",
                city: "",
                cityOK: "",
                cityError: "",
                number: "",
                numberOK: "",
                numberError: "",
            }));
            setLoading(false)
        } finally {
            setLoading(false);
        }
    }
};

export { handleAddressChange };
